export const COLLECTION_SETTINGS_MARKETPLACE_LOGOS_COOKIE_NAME =
  "collectionSettingsMarketplaceLogos"
export const COLLECTION_SETTINGS_RARITY_COOKIE_NAME = "collectionSettingsRarity"

export function parseShowMarketplaceLogos(
  showMarketplaceLogos: string | undefined,
) {
  if (!showMarketplaceLogos) {
    return getDefaultCollectionSettingsMarketplaceLogos()
  }

  return showMarketplaceLogos === "true"
}

export function parseShowRarity(showRarity: string | undefined) {
  if (!showRarity) {
    return getDefaultCollectionSettingsRarity()
  }

  return showRarity === "true"
}

export function getDefaultCollectionSettingsMarketplaceLogos() {
  return true
}

export function getDefaultCollectionSettingsRarity() {
  return true
}
